//Migrated
<template>
  <div
    class="layout-wrapper"
    :class="{ 'bg-gray-50': !$isSol }"
  >
    <slot />
    <slot name="header" />
    <div
      v-if="shouldHaveSolresor"
      class="w-full px-4 top-section layout-container mx-auto"
      :class="containerClass"
    >
      <slot name="solresorContent" />
    </div>
    <div
      class="relative"
      :class="containerClass"
    >
      <div
        v-if="shouldNotBeEmpty"
        class="w-full banner-layout relative"
        :class="[
          `banner-layout-${getBannerSize}`,
          {
            'banner-layout-mobile-compact': hasOnlyBannerBackground
          }
        ]"
      >
        <slot name="banner" />
        <div
          v-if="shouldHaveContainer"
          class="min-h-full w-full"
        >
          <slot name="contentNoWrapper" />
          <slot
            v-if="!$isSol"
            name="sidebar"
          />
          <div
            v-if="shouldHaveWrapper"
            class="flex flex-col px-0 float-print-none"
            :class="{
              'lg:w-9/12': !$isSol && !noContentContainer,
              'container mx-auto': !noContentContainer
            }"
          >
            <slot name="hero" />

            <div :class="{ 'px-page': !noContentContainer }">
              <slot name="content" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot name="footer" />
  </div>
</template>

<script setup>
defineProps({
  containerClass: {
    type: String,
    default: '',
  },

  noContentContainer: {
    type: Boolean,
    default: false,
  },
})

const slots = useSlots()
const rootStore = useRootStore()
const { pageBannerSize, pageBannerTitle, pageBannerSubtitle } = storeToRefs(rootStore)

const hasOnlyBannerBackground = computed(() => {
  return !pageBannerTitle.value && !pageBannerSubtitle.value
})

const getBannerSize = computed(() => pageBannerSize.value ?? 'default')
const shouldHaveWrapper = computed(() => !!slots.hero || !!slots.content)
const shouldHaveContainer = computed(() => !!slots.contentNoWrapper || !!slots.sidebar || shouldHaveWrapper.value)
const shouldNotBeEmpty = computed(() => !!slots.banner || shouldHaveContainer.value)
const shouldHaveSolresor = computed(() => !!slots.solresorContent)
</script>

<style lang="scss">
.layout-head {
  @media (max-width: theme('screens.lg')) {
    height: 550px;
  }

  @media (max-width: theme('screens.md')) {
    max-height: 60vh;
  }

  @media print {
    height: 450px;
  }
}

.layout-container {
  @media (min-width: theme('screens.xl')) {
    width: 90% !important;
  }
}

/*! purgecss start ignore */
.identity--rolfs {
  .layout-head {
    @media (max-width: theme('screens.md')) {
      max-height: 60vh;
    }
  }
  @media (max-width: theme('screens.md')) {
    .banner-layout-mobile-compact .layout-head {
      height: 225px;
      min-height: unset;
      max-height: unset;
    }
  }
}

.identity--solresor {
  .banner-layout-large {
    .layout-container {
      max-width: 1325px;
    }
  }
}

.banner-layout {

  &.banner-layout-small {
    .layout-head {
      height: 420px;
    }
  }

  &.banner-layout-default {
    .layout-head {
      @media (min-width: theme('screens.md')) {
        height: 450px;
      }
    }
  }

  &.banner-layout-large {
    .layout-head {
      height: 450px;

      @media (min-width: theme('screens.md')) {
        height: 700px;
      }
    }
  }
}

.banner-text-container {
  padding: 0 120px;

  .banner-text-subtitle {
    font-size: 2rem;
    line-height: 1.2;
    margin-bottom: 0.5rem;
  }

  @media (max-width: theme('screens.3xl')) {
    padding: 0 0.625em;
  }

  @media (max-width: theme('screens.md')) {
    max-height: 300px;

    .banner-text-title {
      font-size: 3.4rem;
    }
    .banner-text-subtitle {
      font-size: 1.7rem;
    }
  }

  @media (max-width: theme('screens.sm')) {
    padding: 0 16px;
  }

  @media (min-width: theme('screens.sm')) {
    max-height: 300px;
    padding: 0;
  }
}
/*! purgecss end ignore */
</style>
